import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dobFormate } from "helpers";
import { Form, Formik } from "formik";
import moment from "moment";
import dayjs from "dayjs";
import { dayJsDateFormatter } from "utils";
import { Select, CommonButton, DatePicker } from "../../../index";

function ManageUserFilter({ onSubmit, t, onReset, filterData }) {
  const [disableReset, setDisableReset] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);
  // const [clear,setClear] = useState(false)
  const [selectedDate, setSelectedDate] = useState(null); // or initial value

  let initialValues = {
    joinedDate: undefined,
    status: filterData?.status || undefined,
  };
  const arrayOfData = [
    { id: "all", name: "All" },
    {
      id: "active",
      name: "Active",
    },
    {
      id: "inactive",
      name: "Inactive",
    },
  ];
  const handleResetDate = (props) => {
    setSelectedDate(null);
    props.setFieldValue("joinedDate", undefined);
    // Resetting the date to null or any initial value you prefer
  };
  const onHandleReset = (resetForm) => {
    resetForm({});
    setDisableReset(true);

    if (filterData?.joinedDate || filterData?.status) {
      onReset();
    }
  };

  const handleDateChange = (date, props) => {
    setSelectedDate(date);
    props.setFieldValue("joinedDate", dayJsDateFormatter(date, dobFormate));
  };

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={(values) => {
        if (disableSubmit) {
          onSubmit(values);
        }
      }}
      validate={(e) => {
        if (
          e.fullName ||
          e.phoneNumber ||
          e.email ||
          e.joinedDate ||
          e.status
        ) {
          setDisableReset(false);
          setDisableSubmit(true);
        } else {
          setDisableReset(true);
          setDisableSubmit(false);
        }
      }}
    >
      {(props) => {
        return (
          <Form>
            <div className="dropdown-body dropdown-body-rg">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="overline-title overline-title-alt">
                    {t("text.common.dateJoined")}
                  </label>
                  <DatePicker
                    className="form-control"
                    name="joinedDate"
                    id="joinedDate"
                    value={selectedDate}
                    dateFormate={dobFormate}
                    onSelectChange={(e) => {
                      handleDateChange(e, props);
                    }}
                    suffixIcon={<em className="icon-calendar" />}
                    validation
                    defaultValue={
                      filterData?.joinedDate === null ||
                      filterData?.joinedDate === undefined ||
                      filterData?.joinedDate === ""
                        ? undefined || ""
                        : moment(filterData?.joinedDate)
                    }
                    disabledDate={(current) => {
                      return current && current > dayjs().endOf("day");
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <div className="form-group ">
                    <label className="overline-title overline-title-alt">
                      {t("text.common.status")}
                    </label>
                    <Select
                      size="medium"
                      id="status"
                      extraClassName="form-control"
                      name="status"
                      disabled={false}
                      variant="standard"
                      placeholder="Select status"
                      arrayOfData={arrayOfData}
                      setFieldValue={props.handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="dropdown-foot between">
              <Link
                to="#"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  if (!disableReset) {
                    onHandleReset(props.resetForm);
                    handleResetDate(props);
                  }
                }}
                className="clickable"
              >
                {t("text.common.reset")}
              </Link>

              <CommonButton
                extraClassName="btn btn-sm btn-primary"
                type="submit"
              >
                {t("text.common.filter")}
              </CommonButton>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ManageUserFilter;
